<template>
  <div class="main-header">
    <div class="container">
      <div class="header-wrapper">
        <div class="header-left">
          <h1>{{ title }}</h1>
          <h4 class="subtitle" v-if="subtitle">{{ subtitle }}</h4>
        </div>

        <div class="header-right" v-if="firstButtonRoute">
          <b-button block v-if="firstButtonRoute" :to="firstButtonRoute" :variant="firstButtonVariant">
            {{ firstButtonLabel }}
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    title: String,
    subtitle: String,
    firstButtonLabel: String,
    firstButtonRoute: Object,
    firstButtonVariant: String
  }
}
</script>

<style lang="sass">
.main-header
  width: 100%
  // height: 240px
  background: rgba(0, 0, 0, .85)
  margin-bottom: 40px
  .header-wrapper
    overflow: hidden
    height: 100%
    position: relative
    padding: 30px 0 20px
    display: flex
    @media (max-width: 600px)
      display: block

    .header-left
      flex: 1
      h1
        color: white
        margin-bottom: 0
      h4.subtitle
        color: #aaa
    
    .header-right
      width: 300px
      @media (max-width: 600px)
        width: 100%
    
</style>
